const extensionesVideo = ['mp4', 'webm', 'mov', 'ogg', 'mkv'];
const extensionesImagen = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'];

export const esVideo = (nombre) => {
  if (!nombre) return false;
  const ext = nombre.split('.').pop().toLowerCase();
  return extensionesVideo.includes(ext);
};

export const esImagen = (nombre) => {
  if (!nombre) return false;
  const ext = nombre.split('.').pop().toLowerCase();
  return extensionesImagen.includes(ext);
};
